import { render, staticRenderFns } from "./EIzvjestavanjeIndex.vue?vue&type=template&id=1be858fc&scoped=true"
import script from "./EIzvjestavanjeIndex.vue?vue&type=script&lang=js"
export * from "./EIzvjestavanjeIndex.vue?vue&type=script&lang=js"
import style0 from "./EIzvjestavanjeIndex.vue?vue&type=style&index=0&id=1be858fc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1be858fc",
  null
  
)

export default component.exports